export default __webpack_public_path__ + "static/handwriting-a5162cb12ce55d1764f4c5433914c74a.gif";